import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.212 1.667a.581.581 0 100 1.162h3.136l-4.434 4.435a.582.582 0 00.822.821l4.434-4.434v3.137a.582.582 0 001.163 0v-4.54a.581.581 0 00-.581-.581h-4.54zM6.788 18.333a.582.582 0 000-1.162H3.652l4.434-4.435a.581.581 0 10-.822-.821l-4.435 4.434v-3.137a.581.581 0 10-1.162 0v4.54c0 .32.26.581.581.581h4.54z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
